module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "alert animated fadeIn",
    class: ("alert-" + _vm.variant),
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa animated pulse",
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.message) + "\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ba3a7ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/alerts/Alert.vue
// module id = 738
// module chunks = 1